export default __webpack_public_path__ + "static/media/7.32288a5a.webp";